if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
       evt.preventDefault();

       // input fierlds required check
       const openfield = document.querySelector('.open-fields.active');
        const requiredInputs = document.querySelectorAll(".input_element");
        const Atc_error = document.querySelectorAll(".atc-btn-msg");

        let hasError = false;

        requiredInputs.forEach(input => {
          const errorMsg = input.nextElementSibling;

          // ✅ Check if this is addon input
          const isAddonInput = input.classList.contains('related-input-font');

          // 👉 ADDON VALIDATION
          if (isAddonInput) {
            if (openfield && input.hasAttribute("required") && !input.value.trim()) {
              hasError = true;

              if (errorMsg && errorMsg.classList.contains('addon_fields')) {
                errorMsg.style.display = "block";
              }

              input.classList.add("error-input");

            } else {
              if (errorMsg && errorMsg.classList.contains('addon_fields')) {
                errorMsg.style.display = "none";
              }

              input.classList.remove("error-input");
            }
          }

          // 👉 NORMAL VALIDATION
          else {
            if (input.hasAttribute("required") && !input.value.trim()) {
              hasError = true;

              if (errorMsg) errorMsg.style.display = "block";
              input.classList.add("error-input");

            } else {
              if (errorMsg) errorMsg.style.display = "none";
              input.classList.remove("error-input");
            }
          }
        });


        // ✅ ATC ERROR HANDLE (common for both)
        if (hasError) {
          Atc_error.forEach(el => el.style.display = "block");
          return;
        } else {
          Atc_error.forEach(el => el.style.display = "none");
        }
                
          if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
      
       // bundle logic
          const formData = new FormData(this.form);

          // Addon inputs
         const closeFields = document.querySelector('.close-fields');
          const openfields = document.querySelector('.open-fields');

          const fontValue = document.querySelector('.addon-font')?.value || '';
          const textValue = document.querySelector('.related-font-style1')?.value || '';

          const fontValue2 = document.querySelector('.addon-font-2')?.value || '';
          const textValue2 = document.querySelector('.related-font-style2')?.value || '';

          var timestamp = Date.now();
          formData.append('properties[_timestamp]', timestamp);

          let itemIndex = 0; // ⭐ important

          // =======================
          // ✅ 1. OPENFIELDS ADDON (closeFields thi control)
          // =======================
          if (
            openfields &&
            openfields.classList.contains('active') &&
            !(closeFields && closeFields.classList.contains('active')) // 👈 block only here
          ) {
            console.log("openfields addon allowed");

            const qtyInputs_1 = document.querySelectorAll('.condition-wapper');

            qtyInputs_1.forEach((input) => {
              const varid1 = input.getAttribute('data-varid');

              if (varid1) {
 const data = Object.fromEntries(formData.entries());
                // console.log("formData",data);

                formData.append(`items[${itemIndex}][id]`, varid1);
                formData.append(`items[${itemIndex}][quantity]`, 1);
                formData.append(`items[${itemIndex}][properties][_timestamp]`, timestamp);

                formData.append(`items[${itemIndex}][properties][Schriftart]`, fontValue);
                formData.append(`items[${itemIndex}][properties][Dein Wunschtext]`, textValue);

                formData.append(`items[${itemIndex}][properties][Schriftart-2]`, fontValue2);
                formData.append(`items[${itemIndex}][properties][Dein Wunschtext-2]`, textValue2);
                if(data['properties[_Enable QTY]'] == 'true') formData.append(`items[${itemIndex}][properties][_Enable QTY]`, true);

                itemIndex++;
              }
            });
          } else {
            console.log("openfields blocked (due to closeFields active or not active)");
          }

          // =======================
          // ✅ 2. QTY INPUTS ADDON (ALWAYS RUN 🚀)
          // =======================
          console.log("qtyInputs addon always allowed");

          const qtyInputs = document.querySelectorAll('.bundle_item_qty');

          qtyInputs.forEach((input) => {
            const varid = input.getAttribute('data-quantity-variant-id');
            const quantity = parseInt(input.value, 10) || 0;

            if (varid && quantity > 0) {
              formData.append(`items[${itemIndex}][id]`, varid);
              formData.append(`items[${itemIndex}][quantity]`, quantity);
              formData.append(`items[${itemIndex}][properties][_timestamp]`, timestamp);

              formData.append(`items[${itemIndex}][properties][addon Schriftart]`, fontValue);
              formData.append(`items[${itemIndex}][properties][addon Dein Wunschtext]`, textValue);

              formData.append(`items[${itemIndex}][properties][addon Schriftart-2]`, fontValue2);
              formData.append(`items[${itemIndex}][properties][addon Dein Wunschtext-2]`, textValue2);

              itemIndex++;
            }
          });
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
